import Button from "common/components/Button/Button"
import DireccionInputs from "common/components/FormikFields/DireccionInputs"
import FormikInputSwitch from "common/components/FormikFields/FormikInputSwitch"
import { DEFAULT_COUNTRY_SELECTED } from "common/constants/countries"
import { withFormik } from "formik"
import { useTranslation } from "react-i18next"
import { connect } from "react-redux"
import * as Yup from "yup"
import FormikInputText from "../../../../../common/components/FormikFields/FormikInputText"
import {
  validateCodigoPostal,
  validatePoblacion,
  validateProvincia,
} from "../../../../../common/utils/formValidations"
import { getDefaultCountry } from "../../../../Crear/redux/selectors/newDocumentoSettingsSelectors"
import {
  createDireccionEmpresa,
  deleteDireccionEmpresa,
  empresaSelector,
  updateDireccionEmpresa,
} from "../../../redux/slices/empresaSlice"

const FormDirecciones = ({
  handleSubmit,
  setFieldValue,
  deleteDireccionEmpresa,
  initialValues,
  isSubmitting,
  values,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const handleDeleteDireccion = () => {
    deleteDireccionEmpresa(initialValues)
  }

  return (
    <form onSubmit={handleSubmit}>
      <div className='mt-2 text-left'>
        <div className='p-field p-col-12 p-lg-12'>
          <div className='w-full'>
            <div className='d-flex align-items-center justify-content-between'>
              <div className='items-center d-flex'>
                <label htmlFor='direccion'>
                  {t("perfilEmpresa.directions.labelDirection")}
                </label>
              </div>

              <div className='d-flex align-items-center'>
                <FormikInputSwitch name='esFiscal' />
                <span className='mb-1 ml-1'>
                  {t("perfilEmpresa.directions.labelFiscal")}
                </span>
              </div>
            </div>

            <FormikInputText
              className='w-100'
              name='direccion'
              id='direccion'
            />
          </div>
        </div>

        <div className='p-grid p-fluid p-formgrid'>
          <DireccionInputs
            className='text-left col-md-12 col-lg-6 p-field'
            initialCodigoPostal={initialValues.cp}
            showProvincia={false}
            setFieldValue={setFieldValue}
            otherCountries={
              initialValues.countrySelected !== DEFAULT_COUNTRY_SELECTED
            }
            countrySelected={initialValues.countrySelected}
            cpValue={values.cp}
            provinciaValue={values.provincia}
            poblacionValue={values.poblacion}
          />
        </div>

        <div className='justify-start ml-2 d-flex'>
          <Button
            className='!tw-bg-primary'
            loading={isSubmitting}
            type='submit'
          >
            {t("perfilEmpresa.directions.buttonSave")}
          </Button>
          <Button
            onClick={handleDeleteDireccion}
            className='ml-4 text pointer'
          >
            {t("perfilEmpresa.directions.buttonDelete")}
          </Button>
        </div>
      </div>
    </form>
  )
}

const validationSchema = (t: $TSMigrationFixMe) =>
  Yup.object().shape({
    direccion: Yup.string().required(t("errors.directionEmpty")),
    cp: Yup.string().when("isSpain", {
      is: (isSpain: $TSMigrationFixMe) => isSpain === true,
      then: validateCodigoPostal(t),
    }),
    poblacion: validatePoblacion(t),
    provincia: validateProvincia(t),
  })

const mapValuesToApi = (values: $TSMigrationFixMe) => {
  let addressMapped = {
    calle: values?.direccion,
    codigoPostal: values?.cp,
    esFiscal: values.esFiscal,
    id: values?.id,
    empresaId: values?.empresaId,
  }
  if (values?.countrySelected === DEFAULT_COUNTRY_SELECTED) {
    addressMapped = {
      ...addressMapped,
      // @ts-expect-error TS(2322): Type '{ poblacionId: $TSFixMe; provinciaId: $TSFixMe; calle:...
      poblacionId: values?.poblacionId || 0,
      provinciaId: values?.provinciaId || 0,
    }
  } else {
    addressMapped = {
      ...addressMapped,
      // @ts-expect-error TS(2322): Type '{ poblacionExtranjera: $TSFixMe; calle: $TSFixMe; codi...
      poblacionExtranjera: values?.poblacionExtranjera,
    }
  }
  return addressMapped
}

const Actividad = withFormik({
  // @ts-expect-error TS(2339): Property 'data' does not exist on type '{}'.
  mapPropsToValues: ({ data, countrySelected, empresaId }) => ({
    direccion: data?.calle,
    esFiscal: data.esFiscal,
    cp: data?.codigoPostal,
    poblacion: data?.poblacionNombre,
    provincia: data?.provinciaNombre,
    poblacionId: data?.poblacionId,
    provinciaId: data?.provinciaId,
    nuevo: data?.nuevo,
    id: data?.id,
    poblacionExtranjera: data?.poblacionExtranjera,
    countrySelected,
    isSpain: countrySelected === DEFAULT_COUNTRY_SELECTED,
    empresaId,
  }),
  validationSchema: ({ t }: $TSMigrationFixMe) => validationSchema(t),
  handleSubmit: async (values, { props, setSubmitting }) => {
    const data = mapValuesToApi(values)

    setSubmitting(true)
    try {
      if (values.nuevo) {
        // @ts-expect-error TS(2339): Property 'createDireccionEmpresa' does not exist o...
        await props.createDireccionEmpresa(data)
      } else {
        // @ts-expect-error TS(2339): Property 'changeActividadEmpresa' does not exist o...
        await props.changeActividadEmpresa(data)
      }
      setSubmitting(false)
    } catch (e) {
      setSubmitting(false)
    }
  },
})(FormDirecciones)

const mapDispatchToProps = (dispatch: $TSMigrationFixMe) => ({
  changeActividadEmpresa: (payload: $TSMigrationFixMe) =>
    dispatch(updateDireccionEmpresa(payload)),
  deleteDireccionEmpresa: (payload: $TSMigrationFixMe) =>
    dispatch(deleteDireccionEmpresa(payload)),
  createDireccionEmpresa: (payload: $TSMigrationFixMe) =>
    dispatch(createDireccionEmpresa(payload)),
})

const mapStateToProps = (state: $TSMigrationFixMe) => ({
  loadingDireccion: empresaSelector(state).loadingDireccion,
  countrySelected: getDefaultCountry(state),
})

export default connect(mapStateToProps, mapDispatchToProps)(Actividad)
